import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { getToken } from "./auth.js";
import store from '@/store'
import config from '@/utile/config'

// 跨域携带session
axios.defaults.withCredentials = false

const service = axios.create({
  baseURL: config.baseUrl, // api的base_url
  timeout: 115000 // request timeout
})
//请求拦截
service.interceptors.request.use(
  config => {
    if(getToken()){
      config.headers.token = getToken();
    }
    config.headers['Content-Type'] = "application/json";
    if(config.method === 'get'){
      let url = [];
      let data = config.data;
      if(data){
        let keys = Object.keys(data);
        for(let i = 0; i < keys.length; i++){
          url.push(keys[i] + '=' + data[keys[i]]);
        }
        config.url += ('?' + url.join('&'));
      }
    }
    return config
  }, error => {
    return Promise.reject(error)
  })


service.interceptors.response.use(
  response => {
    const res = response.data;
    if(res.code == 200 || res.code==403){
      return Promise.resolve(response.data)
    }else if(res.code == 400){
      Message.error(res.msg);
      return Promise.reject(res.message)
    }else if(res.code==666){
      MessageBox.confirm(`你的登录状态已失效，可以取消继续留在该页面，或者重新登录，失效原因：${ res.msg }`, '确定退出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('logOut').then(res=>{
          location.reload()
        })
      })
      return Promise.reject(res.message)
    }else{
      MessageBox.confirm(`你的登录状态已失效，可以取消继续留在该页面，或者重新登录，失效原因：${ res.msg }`, '确定退出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('logOut').then(res=>{
          location.reload()
        })
      })
      return Promise.reject(res.message)
    }
  },
  error => {
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utile/request.js